/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function UserChangeRequests({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#UserChangeRequests_svg__a)"><path d="M0 0h16v16H0z" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M8.803 4.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M1.226 12.787C1.74 11.127 3.24 10 4.934 10h1.738c1.694 0 3.194 1.127 3.708 2.787l.127.41c.2.645-.27 1.303-.927 1.303H2.026c-.658 0-1.126-.658-.927-1.303z" /><circle cx={1.601} cy={1.601} r={1.601} stroke="currentColor" strokeWidth={1.2} transform="matrix(1 0 0 -1 11.546 9.813)" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M13.147 2.622v3.722M11.203 3.281 13.147 1.5l1.943 1.781" /></g><defs><clipPath id="UserChangeRequests_svg__a"><path d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;